/**
 * @generated SignedSource<<4d287795e7b12c4cca5e739030be23bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserType = "artist" | "partner";
export type ChatThreadQuery$variables = {
  chatId: string;
};
export type ChatThreadQuery$data = {
  readonly chat: {
    readonly hasUnreadMessages: boolean | null;
    readonly id: string;
    readonly other: {
      readonly artist: {
        readonly visible: boolean;
      } | null;
      readonly userType: UserType | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ActionMakeOffer_chat" | "ChatThreadHeading_chat" | "ChatThread_messages" | "MessageInput_chat">;
  } | null;
};
export type ChatThreadQuery = {
  response: ChatThreadQuery$data;
  variables: ChatThreadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chatId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "chatId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnreadMessages",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visible",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActiveAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "spotifyProfile",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ArtistNode",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v11/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isActorInterface"
    },
    (v12/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v14/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v6/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/)
  ],
  "type": "ActorInterface",
  "abstractKey": "__isActorInterface"
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v18 = [
  (v2/*: any*/)
],
v19 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "soundLink",
        "storageKey": null
      },
      (v10/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVisible",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tracksCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseDate",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v9/*: any*/)
        ],
        "type": "UnreleasedReleaseNode",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TrackNodeConnection",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrackNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trackNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SoundRecordingNode",
                        "kind": "LinkedField",
                        "name": "soundRecording",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isrc",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "ReleaseNode",
        "abstractKey": null
      }
    ],
    "type": "ReleaseInterface",
    "abstractKey": "__isReleaseInterface"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChatNode",
        "kind": "LinkedField",
        "name": "chat",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "other",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageInput_chat"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatThread_messages"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatThreadHeading_chat"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ActionMakeOffer_chat"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChatNode",
        "kind": "LinkedField",
        "name": "chat",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "other",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PartnerNode",
                "kind": "LinkedField",
                "name": "partner",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNode",
                    "kind": "LinkedField",
                    "name": "company",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerHasMessaged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "artistHasMessaged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "artistUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numIntrosSendable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nextIntroSendableAt",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "ChatMessageNodeConnection",
            "kind": "LinkedField",
            "name": "messages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessageNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OfferNode",
                        "kind": "LinkedField",
                        "name": "offer",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArtistNode",
                            "kind": "LinkedField",
                            "name": "artist",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v15/*: any*/)
                                ],
                                "type": "ActorInterface",
                                "abstractKey": "__isActorInterface"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "partner",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v2/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "moneyTransferAmountCents",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stripeInvoiceUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "transferRecipient",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "stripeConnectedAccountApiId",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyNode",
                            "kind": "LinkedField",
                            "name": "company",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "providesOwnDistribution",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateOfferAccepted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "terms",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partnerSignature",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "artistSignature",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willTransferCreativeAdvance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willTransferMarketingAdvance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "releases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v19/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "unreleasedReleases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v19/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SoundRecordingNodeConnection",
                                "kind": "LinkedField",
                                "name": "soundRecordings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SoundRecordingNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SoundRecordingNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v18/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "OfferFeaturedDealInterface",
                            "abstractKey": "__isOfferFeaturedDealInterface"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatNode",
                        "kind": "LinkedField",
                        "name": "chat",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "other",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "messages(first:10)"
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ChatThread_messages",
            "kind": "LinkedHandle",
            "name": "messages"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "partnerUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PartnerNode",
                "kind": "LinkedField",
                "name": "partner",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNode",
                    "kind": "LinkedField",
                    "name": "company",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      (v14/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyNode",
                            "kind": "LinkedField",
                            "name": "company",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerNode",
                        "abstractKey": null
                      }
                    ],
                    "type": "ActorInterface",
                    "abstractKey": "__isActorInterface"
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e9093d53f26fbefb68a0305c3cf9e1de",
    "id": null,
    "metadata": {},
    "name": "ChatThreadQuery",
    "operationKind": "query",
    "text": "query ChatThreadQuery(\n  $chatId: ID!\n) {\n  chat(id: $chatId) {\n    id\n    hasUnreadMessages\n    other {\n      userType\n      artist {\n        visible\n        id\n      }\n      id\n    }\n    ...MessageInput_chat\n    ...ChatThread_messages\n    ...ChatThreadHeading_chat\n    ...ActionMakeOffer_chat\n  }\n}\n\nfragment AcceptOfferDialog_chat on ChatNode {\n  id\n}\n\nfragment AcceptOfferDialog_offer on OfferNode {\n  id\n  company {\n    providesOwnDistribution\n    id\n  }\n}\n\nfragment ActionMakeOffer_chat on ChatNode {\n  id\n  partnerUser {\n    partner {\n      ...OfferForm_partner\n      id\n    }\n    id\n  }\n  artistUser {\n    artist {\n      displayName\n      ...OfferForm_artist\n      id\n    }\n    id\n  }\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment ChatThreadHeading_chat on ChatNode {\n  other {\n    userType\n    name\n    lastActiveAt\n    actor {\n      __typename\n      ...AvatarIcon_actor\n      id\n    }\n    artist {\n      visible\n      slug\n      id\n    }\n    partner {\n      displayName\n      company {\n        displayName\n        visible\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ChatThread_messages on ChatNode {\n  messages(first: 10) {\n    edges {\n      node {\n        ...MessageWithOffer_message\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment MessageInput_chat on ChatNode {\n  ...useArtistCanMessageCompany_chat\n  artistUser {\n    artist {\n      ...useArtistCanMessageCompany_artist\n      id\n    }\n    id\n  }\n}\n\nfragment MessageWithOffer_message on ChatMessageNode {\n  id\n  message\n  sentAt\n  offer {\n    id\n    ...OfferMessageStatusUpdate_offer\n  }\n  user {\n    name\n    id\n    actor {\n      __typename\n      ...AvatarIcon_actor\n      id\n    }\n  }\n  ...OfferMessageShell_message\n}\n\nfragment OfferFormHeader_artist on ArtistNode {\n  ...OfferPartnership_artist\n}\n\nfragment OfferFormHeader_partner on PartnerNode {\n  ...OfferPartnership_partner\n}\n\nfragment OfferForm_artist on ArtistNode {\n  id\n  displayName\n  ...OfferFormHeader_artist\n}\n\nfragment OfferForm_partner on PartnerNode {\n  id\n  company {\n    id\n  }\n  ...OfferFormHeader_partner\n}\n\nfragment OfferMessageBody_offer on OfferNode {\n  dateOfferAccepted\n  status\n  terms\n  partnerSignature\n  artistSignature\n  willTransferCreativeAdvance\n  willTransferMarketingAdvance\n  releases {\n    edges {\n      node {\n        ...OfferMessageReleasesIncluded_releases\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        ...OfferMessageReleasesIncluded_unreleasedReleases\n        id\n      }\n    }\n  }\n  artist {\n    displayName\n    ...OfferPartnership_artist\n    id\n  }\n  partner {\n    displayName\n    ...OfferPartnership_partner\n    id\n  }\n  ...OfferNextStep_offer\n  ...OfferMessageReleasesIncluded_offer\n}\n\nfragment OfferMessageCTAArtist_chat on ChatNode {\n  id\n  ...AcceptOfferDialog_chat\n}\n\nfragment OfferMessageCTAArtist_offer on OfferNode {\n  id\n  status\n  ...AcceptOfferDialog_offer\n}\n\nfragment OfferMessageCTAPartner_chat on ChatNode {\n  id\n}\n\nfragment OfferMessageCTAPartner_offer on OfferNode {\n  id\n  status\n  artist {\n    displayName\n    id\n  }\n}\n\nfragment OfferMessageReleasesIncluded_offer on OfferNode {\n  ...ReleasesInfoRemovable_offerFeaturedDeal\n}\n\nfragment OfferMessageReleasesIncluded_releases on ReleaseNode {\n  id\n  ...ReleasesInfoRemovable_release\n}\n\nfragment OfferMessageReleasesIncluded_unreleasedReleases on UnreleasedReleaseNode {\n  id\n  ...ReleasesInfoRemovable_release\n}\n\nfragment OfferMessageShell_message on ChatMessageNode {\n  offer {\n    status\n    ...OfferMessageCTAArtist_offer\n    ...OfferMessageCTAPartner_offer\n    ...OfferMessageBody_offer\n    id\n  }\n  chat {\n    other {\n      name\n      id\n    }\n    ...OfferMessageCTAArtist_chat\n    ...OfferMessageCTAPartner_chat\n    id\n  }\n}\n\nfragment OfferMessageStatusUpdate_offer on OfferNode {\n  artist {\n    displayName\n    id\n  }\n  partner {\n    displayName\n    id\n  }\n  ...OfferNextStep_offer\n}\n\nfragment OfferNextStep_offer on OfferNode {\n  moneyTransferAmountCents\n  stripeInvoiceUrl\n  partner {\n    displayName\n    id\n  }\n  artist {\n    displayName\n    id\n  }\n  transferRecipient {\n    __typename\n    user {\n      id\n    }\n    id\n  }\n  ...useOfferNextStep_offer\n}\n\nfragment OfferPartnership_artist on ArtistNode {\n  ...AvatarName_actor\n}\n\nfragment OfferPartnership_partner on PartnerNode {\n  ...AvatarName_actor\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleasesInfoRemovable_offerFeaturedDeal on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ReleasesInfoRemovable_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  id\n  soundLink\n  thumbnailUrl\n  name\n  ... on UnreleasedReleaseNode {\n    __typename\n  }\n  ... on ReleaseNode {\n    __typename\n    tracks {\n      edges {\n        node {\n          name\n          trackNumber\n          soundRecording {\n            id\n            isrc\n          }\n          id\n        }\n      }\n    }\n  }\n  ...ReleaseDetails_release\n}\n\nfragment useArtistCanMessageCompany_artist on ArtistNode {\n  numIntrosSendable\n  nextIntroSendableAt\n}\n\nfragment useArtistCanMessageCompany_chat on ChatNode {\n  partnerHasMessaged\n  artistHasMessaged\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useOfferNextStep_offer on OfferNode {\n  status\n  moneyTransferAmountCents\n  transferRecipient {\n    __typename\n    user {\n      id\n      stripeConnectedAccountApiId\n    }\n    id\n  }\n  artist {\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "30c030b63cf72a7cc89a6e270e4c40e7";

export default node;
